import { SkillCodes } from "../../manager/components/skill-codes/SkillCodes";

/**
 * @param data  The skill codes data.
 * @param includedYears  The years to include in the search.
 * @returns All included categories for the included years.
 */
export function getIncludedCategories(
  data: SkillCodes,
  includedYears: string[]
) {
  const categories = data.years_order
    .filter((year) => includedYears.includes(year))
    .flatMap((year) => data.years[year].categories);
  return Object.entries(data.categories)
    .filter(([key, value]) => categories.includes(key))
    .map(([key, value]) => value);
}

export const wordToNumber: Record<string, string> = {
  zero: "0",
  one: "1",
  two: "2",
  three: "3",
  four: "4",
  five: "5",
  six: "6",
  seven: "7",
  eight: "8",
  nine: "9",
  ten: "10",
};

export const charPrefixOrSuffixExceptions: Record<string, boolean> = {
  "f'": true,
  "f''": true,
};

export const charWithinStrExceptions: Record<string, string> = {
  "l'hopital": "lhopital",
};
